import Vue from 'vue'
import configs from '@/config'

let resource = null

const actions = {
  getStats: {
    method: 'GET',
    url: `${configs.baseLiveApiUrl}/api/stream/presenter/activity`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const getStats = async (params) => {
  const res = await resource.getStats(params)
  return res.body
}

export default {
  initResource,
  getStats,
}
